import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const EKRapportMeny: IRapportInfo[] = [];

export default EKRapportMeny;
